import XLSX from 'xlsx'

/**
 * excel読み込み
 * promiseを返す
 */
function loadXlsx(path){
	return new Promise(resolve => {
		const req = new XMLHttpRequest();
		req.open('GET', path, true);
		req.responseType = 'arraybuffer';

		req.onload = function () {
			const data = new Uint8Array(req.response);
			const workbook = XLSX.read(data, {type: 'array'});
			let xlsx_data = to_json(workbook);
			resolve(xlsx_data);
		};
		req.send();
	});
}
/**
 * ワークブックのデータをjsonに変換
 * @param workbook
 */
function to_json(workbook) {
	const target_sheetname = workbook.SheetNames[0]; //最初のシート以外は使わない
	const roa = XLSX.utils.sheet_to_json(
		workbook.Sheets[target_sheetname],
		{ raw: true }
	);

	return roa;
}
/**
 * json読み込み
 * promiseを返す
 */
function loadJson(path){
	return new Promise(resolve => {
		const req = new XMLHttpRequest();
		req.open('GET', path, true);
		req.responseType = 'text';

		req.onload = function () {
			const data = JSON.parse(req.response);
			resolve(data);
		};
		req.send();
	});
}

/**
 * オブジェクトが空かどうかを判定する
 * @param obj
 * @return boolean
 */
function empty(obj) {
	return Boolean(Object.keys(obj).length);
}

/**
 * canvasから画像を書き出してブラウザに保存させる
 * @param canvas
 * @param file_name
 */
function downloadCanvas(canvas, file_name) {
	const uri = canvas.toDataURL('image/jpeg', 0.85);
	if (canvas.msToBlob) { //IE対応
		const blob = toBlob(uri);
		window.navigator.msSaveBlob(blob, file_name);
	} else {
		const a = document.createElement('a');
		a.href = uri;
		a.target = '_blank';
		a.download = file_name;
		a.click();
	}
}

/**
 * base64文字列をblobに変換する
 * @param base64
 * @return Blob
 */
function toBlob(base64) {
	const bin = atob(base64.replace(/^.*,/, ''));
	const buffer = new Uint8Array(bin.length);
	for (let i = 0; i < bin.length; i++) {
		buffer[i] = bin.charCodeAt(i);
	}
	const blob = new Blob([buffer.buffer], {type: 'image/png'});
	return blob;
}


export default {loadXlsx, loadJson ,empty, downloadCanvas};
